export default {
    INVITAION_FAILED_MESSAGE : "Invitation Failed",
    ALREADY_INVITE_ERROR_MESSAGE : "This user is already a viewer in the project",
    ALREADY_INVITE_ERROR_CODE:409
}